var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLiveCasino(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.11 9.79H51V4a2 2 0 0 0-4 0v5.79H17V4a2 2 0 0 0-4 0v5.79H8.89A6.9 6.9 0 0 0 2 16.68v38.43A6.9 6.9 0 0 0 8.89 62h46.22A6.9 6.9 0 0 0 62 55.11V16.68a6.9 6.9 0 0 0-6.89-6.89zm-9.32 29.07-5.44 5.31 1.28 7.49a2 2 0 0 1-2.9 2.11L32 50.23l-6.73 3.54a2 2 0 0 1-2.9-2.11l1.28-7.49-5.44-5.31a2 2 0 0 1 1.11-3.41l7.52-1.09 3.37-6.82a2 2 0 0 1 3.58 0l3.37 6.82 7.52 1.09a2 2 0 0 1 1.11 3.41zM58 19.07H6v-2.39a2.9 2.9 0 0 1 2.89-2.89h46.22A2.9 2.9 0 0 1 58 16.68z",
    "data-name": "Layer 24",
    fill: "#4466ef",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveCasino);
export default __webpack_public_path__ + "static/media/LiveCasino.4a482dfea68eb78a90466eaedc97a711.svg";
export { ForwardRef as ReactComponent };